export const DASHBOARD_TABS = {
  TODO: 1,
  OVERVIEW: 2,
  PERFORMANCE: 3,
};

export const PROPERTIES_STATUS = {
  APPRAISAL: 1,
  AVAILABLE: 2,
  RESERVED: 3,
  NOT_AVAILABLE: 4,
};

export const PROPERTY_OPERATIONS = {
  SALE: 'sale',
  RENT: 'rent',
  TEMPORARY: 'temporary',
  COLLEAGUES: 'colleagues',
};

export const INQUIRY_CATEGORIES = {
  SOURCE: 'source',
  OPERATION: 'operation',
};

export const PROPERTY_ADDED_CATEGORIES = {
  TYPE: 'type',
  OPERATION: 'operation',
};

export const TASKS_OPTIONS = {
  TODAY: 'today',
  EXPIRED: 'expired',
};

export const PENDING_REVIEW_VIEW = {
  NEW: 'new',
  MODIFIED: 'modified',
};

export const PROPERTIES_PENDING_REVIEW = 'PropertiesPendingReview';
export const DEVELOPMENTS_PENDING_REVIEW = 'DevelopmentsPendingReview';
export const QPRECO_MARKETPLACE = 'QPrecoMarketplace';
export const MARKETPLACE_REGISTRATION_QUALITY =
  'MarketplaceRegistrationQuality';

export const QPRECO_LEVELS = {
  VERY_HIGH: 'very_high',
  HIGH: 'high',
  GOOD: 'good',
  IDEAL: 'ideal',
  GREAT: 'great',
};

export const MARKETPLACE_QUALITY_LEVELS = {
  BAD: 'bad',
  REGULAR: 'regular',
  GOOD: 'good',
  VERY_GOOD: 'very_good',
};

// Backend bucket ids — quintoandar.constants.PRICE_LABEL_* (tokkobroker)
export const QPRECO_PRICE_LABEL_VALUES = [1, 2, 3, 4, 5];

// Backend bucket ids — quintoandar.constants.COMPLETENESS_QUALITY_* (tokkobroker),
// excludes VERY_BAD (1) since the frontend only surfaces 4 quality levels
export const MARKETPLACE_QUALITY_VALUES = [2, 3, 4, 5];

export const CURRENCIES = {
  ARS: 'ARS',
  USD: 'USD',
  BRL: 'BRL',
  MX: 'MX',
};

export const MAP_OPERATIONS = {
  [PROPERTY_OPERATIONS.SALE]: 1,
  [PROPERTY_OPERATIONS.RENT]: 2,
  [PROPERTY_OPERATIONS.TEMPORARY]: 3,
};

export const TRENDING_STATUS = {
  NEGATIVE: 0,
  POSITIVE: 1,
  NEUTRAL: 2,
};

export const CLOSED_LEADS = {
  CLOSING_REASON: 'closing_reason_breakdown',
  QUALIFICATION: 'qualification_breakdown',
};

export const DONE_VISITS = {
  VISIT: 'visit',
  CLOSING_REASON: 'closing_reason',
  QUALIFICATION: 'qualification',
};

export const DONE_EVENTS = {
  EVENT: 'event',
  CLOSING_REASON: 'closing_reason',
  QUALIFICATION: 'qualification',
};

// Matches EventTypeClosure.QUALIFICATION_* from the card API payload
export const EVENT_QUALIFICATIONS = {
  NEGATIVE: 0,
  POSITIVE: 1,
  NEUTRAL: 2,
};

export const CLOSED_LEADS_QUALIFICATIONS = {
  WITHOUT_IT: 0,
  POSITIVE: 1,
  NEGATIVE: 2,
  NEUTRAL: 3,
};

export const TABLES = {
  NEW_CONTACTS: 'newContacts',
  INQUIRIES_RECEIVED: 'inquiriesReceived',
  DONE_VISITS: 'doneVisits',
  DONE_EVENTS: 'doneEvents',
  CONVERSION_TIME: 'conversionTime',
  RESPONSE_TIME: 'responseTime',
  ADDED_PROPERTIES: 'addedProperties',
  CONVERSION_RATE: 'conversionRate',
  AGENTS_PERFORMANCE: 'agentsPerformance',
  CONCRETED_OPERATIONS: 'concretedOperations',
  PROPERTY_CONSULTATIONS: 'propertyConsultations',
  DEVELOPMENT_CONSULTATIONS: 'developmentConsultations',
  CLOSED_LEADS: 'closedLeads',
  RESERVATIONS_CREATED: 'reservationsCreated',
  PRODUCTION_RATE: 'productionRate',
};

export const TABLE_SORT_FIELDS = {
  CONTACT_NAME: 'contact_name',
  ORIGIN: 'origin',
  DAYS_OF_FOLLOW_UP: 'days_of_follow_up',
  AGENT_NAME: 'agent_name',
  ASSIGNMENT_DATE: 'assignment_date',
  PROPERTY_ADDRESS: 'property_address',
  PROPERTY_TYPE: 'property_type',
  OPERATION: 'operation',
  ENTRY_DATE: 'entry_date',
  WHEN: 'when',
  CONVERSION_TIME: 'conversion_time',
  LOCATION: 'location',
  OPERATION_AMOUNT: 'operation_amount',
  RESPONSE_TIME: 'response_time',
  MEDIAN_RESPONSE_TIME: 'average_response_time',
  ASSIGNED_CONTACTS: 'assigned_contacts',
  ANSWERED_CONTACTS: 'responded_contacts',
  UNATTENDED_CONTACTS_AND_REASSIGNED: 'unattended_reassigned_contacts',
  WITH_VISITS: 'with_visits',
  WITH_RESERVATIONS: 'with_reservations',
  CONCRETED: 'concreted',
  LOST: 'lost',
  IN_PROGRESS: 'in_progress',
  CONVERSION_RATE: 'conversion_rate',
  VISIT_TYPE: 'visit_type',
  VALUE: 'value',
  OWNER_NAME: 'owner_name',
  INQUIRIES: 'inquiry',
  AGENTS_IN_CHARGE: 'agents_in_charge',
  AVAILABLE_UNITS: 'units_available',
  CONSTRUCTION_STATUS: 'construction_status',
  DEVELOPMENT_TYPE: 'development_type',
  DEVELOPMENT_NAME: 'development_name',
  CLOSING_REASON: 'closing_reason',
  QUALIFICATION: 'qualification',
  ASSIGNAMENT_DATE: 'assignment_date',
  RESERVATION_VALUE: 'reservation_value',
  STATUS: 'status',
  CREATED_AT: 'created_at',
  EXPIRATION_DATE: 'expiration_date',
  SAVED_SEARCHES: 'saved_searches',
  SHARED_FILES: 'shared_files',
  EVENTS: 'events',
  COMPLETED_OPERATIONS: 'completed_operations',
  PRODUCTION_RATE: 'production_rate',
  APPRAISED: 'appraised',
  ENTERED: 'entered',
  FALLEN: 'fallen',
  CLOSE_DATE: 'close_date',
  EVENT_TYPE: 'event_type',
};

export const DOWNLOAD_EXCEL_PATHS = {
  [TABLES.NEW_CONTACTS]: 'api3/reports/new_contacts_table_excel',
  [TABLES.INQUIRIES_RECEIVED]: 'api3/reports/received_inquiries_table_excel',
  [TABLES.DONE_VISITS]: 'api3/reports/visit_events_table_excel',
  [TABLES.DONE_EVENTS]: 'api3/reports/done_events_table_excel',
  [TABLES.CONVERSION_TIME]: 'api3/reports/conversion_time_table_excel',
  [TABLES.RESPONSE_TIME]: 'api3/reports/response_time_table_excel',
  [TABLES.ADDED_PROPERTIES]:
    'api3/reports/new_property_availability_table_excel',
  [TABLES.CONVERSION_RATE]: 'api3/reports/conversion_rate_table_excel',
  [TABLES.AGENTS_PERFORMANCE]: 'api3/reports/agent_performance_table_excel',
  [TABLES.CONCRETED_OPERATIONS]:
    'api3/reports/concreted_operations_table_excel',
  [TABLES.PROPERTY_CONSULTATIONS]:
    'api3/reports/property_consultations_table_excel',
  [TABLES.DEVELOPMENT_CONSULTATIONS]:
    'api3/reports/development_consultations_table_excel',
  [TABLES.CLOSED_LEADS]: 'api3/reports/closed_leads_table_excel',
  [TABLES.RESERVATIONS_CREATED]: 'api3/reports/reservation_table_excel',
  [TABLES.PRODUCTION_RATE]: 'api3/reports/production_rate_table_excel',
};

export const CONCRETED_OPERATIONS_INFORMATION = {
  QUANTITY: 'quantity',
  TOTAL_VALUE_USD: 'total_value_usd',
};
